"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(config, app) {
    var _a = app.env, env = _a === void 0 ? '' : _a, _b = app.system, system = _b === void 0 ? '' : _b;
    config = config[env] || config;
    if (!config[system]) {
        return typeof config.factory === 'function' ? config : null;
    }
    var isCurrent = true;
    if (config.compatible && typeof config.compatible.hit === 'function') {
        isCurrent = !config.compatible.hit.call(this, app);
    }
    var currentConfig = isCurrent ? config[system] : config.compatible;
    if (typeof currentConfig.type !== 'function' && typeof currentConfig.factory !== 'function') {
        return null;
    }
    return currentConfig;
}
exports.default = default_1;
